import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layout/AdminLayout";
import { useAuth } from "../../../context/AuthContext";
import * as model from "../../../models/ClientsModel";
import { apiError } from "../../../helpers/ErrorHelper";
import PageHeader from "../../common/PageHeader";
import { Helmet } from "react-helmet";
import { MySelect, Text, TextArea, TextFloat, TextNumber } from '../../inputs/inputs';
import { getCountries, getStates, getCurrencies } from '../../../models/MasterModel';
import { formatDataBeforeDisplay, formatDataBeforeSend, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { checkPermission } from "../../../helpers/GeneralHelper";
import ClientBranches from "./ClientBranches";

export default function ClientEdit() {
  const location = useLocation();
  // console.log(location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length));
  const isEdit = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'edit';
  const isView = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'view';
  const module = {
    title: (isView ? 'View' : isEdit ? 'Edit' : 'Add')+' Client', //isEdit ? 'Edit Client' : 'View Client',
    singularTitle: 'Client',
    key: 'clients',
    route: 'clients',
    primaryCol: '_client_id',
  };
  const baseURL = process.env.REACT_APP_BASE_URL;

  //const module = location.state?.module;
  const data = location.state?.data;
  const { unique_id } = useParams(); // Get the client ID from the URL
  const navigate = useNavigate();
  const { state } = useAuth();
  const [id, setId] = useState('');
  // const [isTrash, setIsTrash] = useState(false);

  // const fetchTrash = (isTrash) => {
  //   setIsTrash(() => (isTrash));
  // }
  const user_token = state.user_data?.user_token;

  const [loading, setLoading] = useState(true);

  const inputFields = {
    client_name: '',
    client_domain: '',
    client_msa_status: '',
    client_size: '',
    client_revenue: '',
    client_presence: '',
    client_is_msp: '0',
    client_msp_name: '',
    client_is_vms_tool_used: '0',
    client_link: '',
    client_login_username: '',
    client_login_password: '',
    client_website: '',
    client_country: '',
    client_billing_state: '',
    client_address: '',
    client_remarks: '',
    client_currency: '',
    client_gstin: '',
    client_pincode: '',
    client_state_other: '',
    client_state_code: ''
  }
  const formatOptions = [];

  const yesNoOptions = [
    { value: 1, label: 'Yes'},
    { value: 0, label: 'No'},
  ];
  const [fields, setFields] = useState(inputFields);
  const [errors, setErrors] = useState({});
  const [states, setStates] = useState([]);
  const { notificationCount, setNotificationCount } = useNotificationCount();
  const [currencies, setCurrencies] = useState([]);
  const fetchCurrencies = async () => {
    try {
      const result = await getCurrencies();

      const currenciesOptions = result.currencies.map(currency => ({
        label: currency.currency_name,
        value: currency._currency_id
      }));

      setNotificationCount(localStorage.getItem('unread_notification_count'));

      setCurrencies(currenciesOptions);
    } catch (error) {
      //console.error(error);
    }
  };
  const [countries, setCountries] = useState([]);
  const fetchCountries = async () => {
    try {
      const result = await getCountries();

      const countriesOptions = result.countries.map(country => ({
        label: country.country_name,
        value: country._country_id
      }));

      setNotificationCount(localStorage.getItem('unread_notification_count'));

      setCountries(countriesOptions);
    } catch (error) {
      //console.error(error);
    }
  };
  useEffect(() => {
    fetchCountries();
    fetchCurrencies();
  }, []);
  const fetchStates = async (_country_id = null) => {
    if(_country_id==99){
      try {
        const result = await getStates({user_token: user_token, page: 1, limit: -1, _country_id : _country_id});
  
        const options = result.states.map(row => ({
          value: row._state_id,
          label: row.state_name
        }));
  
        setStates(options);
        fields.client_state_other = '';
        fields.client_state_code = '';
      } catch (error) {
        console.error(error);
      }
    }else{
      fields.client_billing_state = '';
      setStates([]);
      return;
    }
  };
  const countryChange = async(value) => {
    //console.log(value);
    fetchStates(value);
  }
  const validator = useRef(new SimpleReactValidator(validorSettings()));
  // Fetch the client data when the component loads
  useEffect(() => {
    if(unique_id !=''){

    const fetchClientData = async () => {
      try {
        const response = await model.getSingleData({
          user_token: user_token,
          id: unique_id, // Assuming _client_id is the identifier in your data
        });

        if (response && response.client) {
          setFields(formatDataBeforeDisplay(response.client, formatOptions));
          setId(response.client._client_id);
          if(response.client.client_country != null){
            fetchStates(response.client.client_country);
          }
        } else {
          toast.error("Client not found.");
          navigate("/clients"); // Redirect if client not found
        }
      } catch (error) {
        apiError(error);
        //console.error("Failed to fetch client data:", error);
        toast.error("Failed to fetch client data.");
      } finally {
        setLoading(false);
      }
    };

    fetchClientData();
  }
  }, [unique_id, user_token, navigate]);

  // Handle form submission
  const handleSubmit = async (e) => {
    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      let response;
      response = await model.update(user_token, id, formData);
      
      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        model.saveToStorage(response.data[module.key], response.data.pagination);
        navigate("/clients"); // Redirect back to clients list
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  };

  return (
    <AdminLayout>
      <Helmet>
        <title>{module.title} - Digital CMS</title>
      </Helmet>
      <div className="main-content app-content">
        <div className="container-fluid cms-form-shell">
        <PageHeader module={module}  />

          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      {(isView && checkPermission(module.route, 'edit'))? 
                      <div className="row gy-2 mb-3">
                        <div className="col-xl-11 "></div>
                        <div className="col-xl-1 ml-3" style={{ textAlign:"right" }}>
                        {checkPermission(module.route, 'edit') && (
            <button
              type="button"
              className="btn btn-icon btn-sm btn-info"
              title="Edit"
              onClick={() => navigate(`/clients/${unique_id}/edit`)} // Navigate to the edit page
            >
              <i className='bx bxs-edit'></i>
            </button>
          )}
                        </div>
                      </div>
                      : ''}
                    
                    <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <Text column="client_name" label="Client Name" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
              
              <div className="col-xl-4">
                <Text column="client_domain" label="Domain / LOB" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
              
              <div className="col-xl-4">
                <Text column="client_msa_status" label="MSA Status" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <TextNumber column="client_size" label="Size" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>

              <div className="col-xl-4">
                <TextFloat column="client_revenue" label="Revenue" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>

              <div className="col-xl-4">
                <Text column="client_presence" label="Presence" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <MySelect options={yesNoOptions} firstOption={false} column="client_is_msp" label="Is MSP?" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
              
              <div className="col-xl-4" style={{display: (fields.client_is_msp == 1 ? 'block' : 'none')}}>
                <div>
                  <Text column="client_msp_name" label="MSP Name" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                </div>
              </div>
              
              <div className="col-xl-4">
                <MySelect options={yesNoOptions} firstOption={false} column="client_is_vms_tool_used" label="VMS Tool Used" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
            </div>

            <div className="row gy-2 mb-3" style={{display: (fields.client_is_vms_tool_used == 1 ? 'flex' : 'none')}}>
              <div className="col-xl-4">
                <Text column="client_link" label="VMS Link" fields={fields} setFields={setFields} errors={errors} validator={validator} rules='url' disabled={isView} />
              </div>
              
              <div className="col-xl-4">
                <Text column="client_login_username" label="VMS Username" fields={fields} setFields={setFields} errors={errors} disabled={isView}/>
              </div>
              
              <div className="col-xl-4">
                <Text column="client_login_password" label="VMS Password" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
            </div>

            <div className="row gy-2 mb-3">

              <div className={(fields.client_country == 99 || fields.client_country=='') ? "col-xl-4" : "col-xl-3"}>
                <MySelect options={countries} onChange={countryChange}
                 column="client_country" label="Client Country" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
              
              <div className={(fields.client_country == 99 || fields.client_country=='') ? "col-xl-4" : "col-xl-3"} style={{display: (fields.client_country == 99 ? 'block' : 'none')}}>
                <MySelect options={states} column="client_billing_state" label="Billing State" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>

              <div className={(fields.client_country == 99 || fields.client_country=='') ? "col-xl-4" : "col-xl-3"} style={{display: ((fields.client_country !='' && fields.client_country != 99) ? 'block' : 'none')}}>
                <Text column="client_state_other" label="Province/State" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>

              <div className={(fields.client_country == 99 || fields.client_country=='') ? "col-xl-4" : "col-xl-3"} style={{display: ((fields.client_country !='' && fields.client_country != 99) ? 'block' : 'none')}}>
                <Text column="client_state_code" label="State Code" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>

              <div className={(fields.client_country == 99 || fields.client_country=='') ? "col-xl-4" : "col-xl-3"}>
                <Text column="client_pincode" label={fields.client_country == 99 ? 'Pincode' : 'Zipcode'} fields={fields} setFields={setFields} errors={errors} validator={validator} disabled={isView} />
              </div>

            </div>
            <div className="row gy-2 mb-3">
              <div className="col-xl-4">
                <Text column="client_website" label="Website" fields={fields} setFields={setFields} errors={errors} validator={validator} rules='url' disabled={isView} />
              </div>
              <div className="col-xl-4">
                <MySelect options={currencies} column="client_currency" label="Currency" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
              <div className="col-xl-4">
                <Text column="client_gstin" label="Client GST" fields={fields} setFields={setFields} errors={errors} validator={validator} disabled={isView} />
              </div>
            </div>

            <div className="row gy-2 mb-3">
              <div className="col-xl-6">
                <TextArea column="client_address" label="Address" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>

              <div className="col-xl-6">
                <TextArea column="client_remarks" label="Remarks" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
              </div>
            </div>
                      { isEdit ?
                      <button type="submit" className="btn btn-primary" disabled={loading} >
                        {loading ? "Updating..." : "Update Client"}
                      </button>
                       : '' }
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-header">
                    <div className="card-title">Branches (GSTIN / Address)</div>
                  </div>
                  <div className="card-body">
                    <ClientBranches
                      clientId={id}
                      isView={isView}
                      moduleRoute={module.route}
                    />
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <h5 className="card-title mb-3">Links</h5>
                    <div className="row gy-2 mb-3">
                      <div className="col-md-2">
                        {/* <a href={`/contacts/?_client_id=${id}`} className="btn w-100 btn-success">POCS</a> */}
                        <Link to={`/contacts/?_client_id=${id}`} className="btn w-100 btn-success">POCS</Link>
                      </div>
                      <div className="col-md-2">
                        {/* <a href={`/requirements/?_client_id=${id}`} className="btn w-100 btn-success">Requirements</a> */}
                        <Link to={`/requirements/?_client_id=${id}`} className="btn w-100 btn-success">Requirements</Link>
                      </div>
                      <div className="col-md-3">
                        {/* <a href={`/candidates/?_client_id=${id}`} className="btn w-100 btn-success">Candidates</a> */}
                        <Link to={`/candidates/?_client_id=${id}`} className="btn w-100 btn-success">Candidates</Link>
                      </div>
                      <div className="col-md-3">
                        {/* <a href={`/interviews/?_client_id=${id}`} className="btn w-100 btn-success">Interviews</a> */}
                        <Link to={`$/interviews/?_client_id=${id}`} className="btn w-100 btn-success">Interviews</Link>
                      </div>
                      <div className="col-md-2">
                        {/* <a href={`/onboards/?_client_id=${id}`} className="btn w-100 btn-success">Onboards</a> */}
                        <Link to={`/onboards/?_client_id=${id}`} className="btn w-100 btn-success">Onboards</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}